;
var sprite = require("/tmp/build_133e1b25/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_ReferenceNumber_9656548d598afbad5273a939439e54b5\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M59.731,69.314H40.27v15.959h-4.574V69.314H19.447v-4.28h16.249V34.966H19.447v-4.282h16.249V14.726h4.574v15.958h19.461\r\n\t\tV14.726h4.573v15.958h16.25v4.282h-16.25v30.068h16.25v4.28h-16.25v15.959h-4.573V69.314z M59.731,34.966H40.27v30.068h19.461\r\n\t\tV34.966z\"/> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_ReferenceNumber_9656548d598afbad5273a939439e54b5");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_ReferenceNumber.svg
// module id = 1412
// module chunks = 0